import { useState } from "react"
import type { ChangeEvent, FormEvent } from "react"
import { useNavigate } from "react-router-dom"
import { useAdminAuth } from "@/domain/admin/hooks/AdminAuthHook"

/**
 * 관리자 로그인 화면.
 *
 * 실패 사유(없는 아이디 · 틀린 비밀번호 · 잠긴 계정)는 서버가 구분해 주지 않는다 —
 * 아이디가 있는지를 화면이 알려주면 열거에 쓰이기 때문이다.
 */
export default function AdminLoginPage() {
  const navigate = useNavigate()
  const { useAdminAuthState, login } = useAdminAuth()
  const { isLoading, errorMessage } = useAdminAuthState()

  const [loginId, setLoginId] = useState("")
  const [password, setPassword] = useState("")

  function onChangeLoginId(event: ChangeEvent<HTMLInputElement>) {
    setLoginId(event.target.value)
  }

  function onChangePassword(event: ChangeEvent<HTMLInputElement>) {
    setPassword(event.target.value)
  }

  function onSubmitLogin(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()

    void login({ loginId, password }).then((isSuccess) => {
      if (isSuccess) navigate("/admin", { replace: true })
    })
  }

  const fieldClass = "focus-ring app-field"

  return (
    <section className="app-page max-w-md">
      <p className="app-txt-eyebrow text-app-primary-600">ADMIN</p>
      <h1 className="app-txt-h1 mt-3">관리자 로그인</h1>
      <p className="app-txt-body2 mt-3 leading-6 text-app-text-300">
        대회와 참가자, 대진표를 관리하려면 로그인이 필요합니다.
      </p>

      <form
        onSubmit={onSubmitLogin}
        noValidate
        className="app-card mt-8"
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <label
              htmlFor="admin-login-id"
              className="app-label"
            >
              아이디
            </label>
            <input
              id="admin-login-id"
              type="text"
              autoComplete="username"
              value={loginId}
              maxLength={50}
              onChange={onChangeLoginId}
              className={fieldClass}
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <label
              htmlFor="admin-password"
              className="app-label"
            >
              비밀번호
            </label>
            <input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              maxLength={50}
              onChange={onChangePassword}
              className={fieldClass}
            />
          </div>
        </div>

        {errorMessage && (
          <p
            role="alert"
            className="app-alert app-alert-error mt-5"
          >
            {errorMessage}
          </p>
        )}

        <button
          type="submit"
          disabled={isLoading}
          className="focus-ring app-btn app-btn-primary app-btn-block mt-6"
        >
          로그인
        </button>

        <p className="app-field-help mt-5">
          비밀번호를 5회 연속 틀리면 계정이 잠깁니다. 잠긴 경우 마스터
          관리자에게 문의해 주세요.
        </p>
      </form>
    </section>
  )
}
